import { API_URL } from "../config/backend";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Crewmate from "../components/Crewmate";

const API = API_URL;

const STEPS = [
  { n:"1", title:"Открой на большом экране", desc:"Хост открывает neonparty.ru на ноутбуке или ТВ, выбирает игру и создаёт комнату.", color:"#ff3cac", bg:"#ff3cac" },
  { n:"2", title:"Поделись кодом",            desc:"4-буквенный код — игроки вводят его на своих телефонах. Всё через браузер.", color:"#ffe600", bg:"#ffe600" },
  { n:"3", title:"Играйте!",                  desc:"Телефон каждого — пульт управления. Хост-экран показывает игровое поле.", color:"#3dffa0", bg:"#3dffa0" },
];

const FEATURES = [
  { emoji:"📱", title:"Без приложений",     desc:"Всё работает в браузере. Просто открой сайт.", color:"#ff3cac" },
  { emoji:"🖥️", title:"Один большой экран", desc:"Хост-экран + телефоны игроков. Идеально для ТВ или ноутбука.", color:"#00f5ff" },
  { emoji:"⚡",  title:"Мгновенный старт",   desc:"От входа до первого раунда — меньше минуты.", color:"#ffe600" },
  { emoji:"👥",  title:"1–16 игроков",       desc:"Лимит зависит от выбранной игры.", color:"#3dffa0" },
];

const FAQ = [
  { q:"Нужно ли скачивать приложение?",            a:"Нет. NeonParty работает прямо в браузере — Safari, Chrome, Firefox — всё подходит." },
  { q:"Сколько человек может играть?",              a:"От 1 до 16 игроков, в зависимости от выбранной игры. Один хост с большим экраном, остальные подключаются с телефонов." },
  { q:"Что такое PRO игры?",                        a:"PRO игры доступны по промо-коду. Купи код на странице PRO — там три тарифа на любой бюджет." },
  { q:"Работает ли без интернета?",                 a:"Нет, нужен интернет — игроки общаются через сервер в реальном времени." },
  { q:"На каких устройствах работает хост-экран?",  a:"На любом устройстве с браузером: ноутбук, Smart TV, планшет, ПК. Чем больше экран — тем лучше." },
];

function GameCard({ game, isPro }) {
  const accent = isPro ? "#9b5de5" : "#3dffa0";
  return (
    <div style={{
      background: "#16103a",
      border: `2.5px solid ${accent}`,
      borderRadius: "1rem",
      boxShadow: `3px 3px 0 #000`,
      padding: "1rem 1.1rem",
      display: "flex", gap: "0.85rem", alignItems: "flex-start",
      transition: "transform 0.1s",
    }}
      onMouseEnter={e => e.currentTarget.style.transform = "translate(-2px,-2px)"}
      onMouseLeave={e => e.currentTarget.style.transform = "translate(0,0)"}
    >
      <span style={{ fontSize: "1.75rem", flexShrink: 0 }}>{game.emoji || "🎮"}</span>
      <div>
        <p style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1rem", color: "#fff", marginBottom: "0.2rem" }}>
          {game.name}
        </p>
        <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.82rem", color: "#aaa", lineHeight: 1.5 }}>
          {game.description}
        </p>
      </div>
    </div>
  );
}

function GamesSection({ games, loading }) {
  if (loading) return (
    <div style={{ textAlign: "center", padding: "2rem", color: "#555", fontFamily: "'Nunito', sans-serif" }}>
      Загрузка игр...
    </div>
  );

  const freeGames = games.filter(g => g.tier === "free" && g.disabled !== true);
  const proGames  = games.filter(g => g.tier === "pro"  && g.disabled !== true);

  return (
    <>
      {freeGames.length > 0 && (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: "0.6rem", marginBottom: "1rem" }}>
            <span style={{
              background: "#3dffa0", color: "#000",
              border: "2.5px solid #000", borderRadius: "0.6rem",
              boxShadow: "2px 2px 0 #000",
              padding: "0.2rem 0.75rem",
              fontFamily: "'Fredoka One', sans-serif", fontSize: "0.85rem",
            }}>🆓 БЕСПЛАТНО</span>
            <span style={{ fontFamily: "'Nunito', sans-serif", color: "#555", fontSize: "0.82rem" }}>— доступны без кода</span>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(270px,1fr))", gap: "0.85rem", marginBottom: "2.5rem" }}>
            {freeGames.map(g => <GameCard key={g.id} game={g} isPro={false} />)}
          </div>
        </>
      )}
      {proGames.length > 0 && (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: "0.6rem", marginBottom: "1rem" }}>
            <span style={{
              background: "#9b5de5", color: "#fff",
              border: "2.5px solid #000", borderRadius: "0.6rem",
              boxShadow: "2px 2px 0 #000",
              padding: "0.2rem 0.75rem",
              fontFamily: "'Fredoka One', sans-serif", fontSize: "0.85rem",
            }}>🔒 PRO</span>
            <span style={{ fontFamily: "'Nunito', sans-serif", color: "#555", fontSize: "0.82rem" }}>— нужен промо-код</span>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(270px,1fr))", gap: "0.85rem" }}>
            {proGames.map(g => <GameCard key={g.id} game={g} isPro={true} />)}
          </div>
        </>
      )}
    </>
  );
}

export default function AboutPage() {
  const navigate = useNavigate();
  const [games,   setGames]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    fetch(`${API}/games`)
      .then(r => r.json())
      .then(data => setGames((data.games || data || []).filter(g => g.disabled !== true)))
      .catch(() => setGames([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page-root" style={{ minHeight: "100vh", color: "#fff" }}>
      <Navbar />
      <div style={{ maxWidth: "960px", margin: "0 auto", padding: "3rem 1.5rem 5rem" }}>

        {/* ── HERO ── */}
        <div style={{ textAlign: "center", marginBottom: "4rem" }}>
          <div style={{ display: "flex", justifyContent: "center", gap: "1rem", marginBottom: "1.5rem" }}>
            <Crewmate color="#ff3cac" size={52} animate="bounce" />
            <Crewmate color="#ffe600" size={52} animate="bounce" />
            <Crewmate color="#00f5ff" size={52} animate="bounce" />
            <Crewmate color="#3dffa0" size={52} animate="bounce" />
          </div>
          <h1 style={{
            fontFamily: "'Fredoka One', sans-serif",
            fontSize: "clamp(2.2rem,6vw,4rem)",
            color: "#fff", lineHeight: 1.1,
            textShadow: "4px 4px 0 #ff3cac, 8px 8px 0 #000",
            marginBottom: "1.25rem",
          }}>ЧТО ТАКОЕ NEONPARTY?</h1>
          <p style={{
            fontFamily: "'Nunito', sans-serif", fontSize: "1.1rem",
            color: "#bbb", maxWidth: "640px", margin: "0 auto", lineHeight: 1.75,
          }}>
            Онлайн-платформа вечериночных мини-игр для компании.
            Один большой экран, телефоны как пульты — и никаких скучных вечеров.{" "}
            <strong style={{ color: "#fff" }}>Без установки. Прямо в браузере.</strong>
          </p>
        </div>

        {/* ── FEATURES ── мультяшные карточки ── */}
        <section style={{ marginBottom: "4rem" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px,1fr))", gap: "1rem" }}>
            {FEATURES.map(f => (
              <div key={f.title} className="card-cartoon" style={{ textAlign: "center", padding: "1.5rem 1rem" }}>
                <div style={{
                  display: "inline-flex", alignItems: "center", justifyContent: "center",
                  background: f.color, border: "2.5px solid #000",
                  borderRadius: "1rem", boxShadow: "3px 3px 0 #000",
                  width: "3.5rem", height: "3.5rem",
                  fontSize: "1.75rem", marginBottom: "0.85rem",
                }}>{f.emoji}</div>
                <p style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1.05rem", color: "#fff", marginBottom: "0.4rem" }}>{f.title}</p>
                <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.85rem", color: "#aaa", lineHeight: 1.5 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── КАК ЭТО РАБОТАЕТ ── */}
        <section style={{ marginBottom: "4rem" }}>
          <h2 style={{
            fontFamily: "'Fredoka One', sans-serif", fontSize: "1.75rem",
            color: "#ffe600", marginBottom: "1.75rem", textAlign: "center",
            textShadow: "3px 3px 0 #ff8c00, 5px 5px 0 #000",
          }}>КАК ЭТО РАБОТАЕТ</h2>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px,1fr))", gap: "1.25rem" }}>
            {STEPS.map((s, i) => (
              <div key={s.n} className="card-cartoon" style={{ padding: "1.5rem" }}>
                <div style={{
                  width: "2.75rem", height: "2.75rem",
                  background: s.bg, border: "2.5px solid #000",
                  borderRadius: "0.75rem", boxShadow: "3px 3px 0 #000",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontFamily: "'Fredoka One', sans-serif", fontSize: "1.4rem",
                  color: "#000", marginBottom: "1rem",
                }}>{s.n}</div>
                <h3 style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1.1rem", color: "#fff", marginBottom: "0.5rem" }}>{s.title}</h3>
                <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.9rem", color: "#aaa", lineHeight: 1.6 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── ВСЕ ИГРЫ ── */}
        <section style={{ marginBottom: "4rem" }}>
          <h2 style={{
            fontFamily: "'Fredoka One', sans-serif", fontSize: "1.75rem",
            color: "#00f5ff", marginBottom: "1.75rem", textAlign: "center",
            textShadow: "3px 3px 0 #0088aa, 5px 5px 0 #000",
          }}>ВСЕ ИГРЫ</h2>
          <GamesSection games={games} loading={loading} />
        </section>

        {/* ── FAQ ── аккордеон ── */}
        <section style={{ marginBottom: "4rem" }}>
          <h2 style={{
            fontFamily: "'Fredoka One', sans-serif", fontSize: "1.75rem",
            color: "#ff3cac", marginBottom: "1.75rem", textAlign: "center",
            textShadow: "3px 3px 0 #aa0066, 5px 5px 0 #000",
          }}>ЧАСТЫЕ ВОПРОСЫ</h2>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
            {FAQ.map((item, i) => (
              <div key={i} className="card-cartoon" style={{ padding: "0", overflow: "hidden", cursor: "pointer" }}
                onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <div style={{
                  display: "flex", justifyContent: "space-between", alignItems: "center",
                  padding: "1rem 1.25rem",
                }}>
                  <p style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1rem", color: "#fff", margin: 0 }}>{item.q}</p>
                  <span style={{
                    fontFamily: "'Fredoka One', sans-serif", fontSize: "1.25rem",
                    color: "#ff3cac", flexShrink: 0, marginLeft: "1rem",
                    transition: "transform 0.2s",
                    transform: openFaq === i ? "rotate(45deg)" : "rotate(0deg)",
                    display: "inline-block",
                  }}>+</span>
                </div>
                {openFaq === i && (
                  <div style={{ padding: "0 1.25rem 1rem", borderTop: "2px solid #000" }}>
                    <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.9rem", color: "#aaa", lineHeight: 1.65, margin: 0, paddingTop: "0.75rem" }}>{item.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* ── CTA ── */}
        <div style={{ textAlign: "center" }}>
          <button
            onClick={() => navigate("/")}
            className="btn-cartoon btn-primary"
            style={{ padding: "1rem 3rem", fontSize: "1.3rem" }}
          >
            🎮 Начать играть →
          </button>
        </div>

      </div>
    </div>
  );
}
